var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.79082 0C1.70068 0 0 1.70168 0 3.79234V9.20867C0 11.2991 1.70168 13 3.79234 13H9.20867C11.2991 13 13 11.2983 13 9.20766V3.79082C13 1.70068 11.2983 0 9.20766 0H3.79082ZM10.4 2.08C10.687 2.08 10.92 2.31296 10.92 2.6C10.92 2.88704 10.687 3.12 10.4 3.12C10.113 3.12 9.88 2.88704 9.88 2.6C9.88 2.31296 10.113 2.08 10.4 2.08ZM6.5 3.12C8.3642 3.12 9.88 4.6358 9.88 6.5C9.88 8.3642 8.36394 9.88 6.5 9.88C4.6358 9.88 3.12 8.36394 3.12 6.5C3.12 4.63606 4.6358 3.12 6.5 3.12ZM6.5 4.16C5.20754 4.16 4.16 5.20754 4.16 6.5C4.16 7.79246 5.20754 8.84 6.5 8.84C7.79246 8.84 8.84 7.79246 8.84 6.5C8.84 5.20754 7.79246 4.16 6.5 4.16Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.02f5601c31869a54395cc39b2c2d0fc1.svg";
export { ForwardRef as ReactComponent };